module.exports = __webpack_public_path__ + "img/not-found.b2701421.png";